<template>
  <div ref="myEcharts" :style="{ height, width }"></div>
</template>
<script>
import { ref, onMounted } from "vue";
import * as echarts from "echarts";
export default {
  name: "baseBar",
  props: {
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    rate: {
      type: String,
      default: "",
    },
    datas: {
      type: Array,
      default: [],
    },
  },
  setup(props) {
    // console.log(props);
    const myEcharts = ref(null);
    const chart = new InitChart(props, myEcharts);
    onMounted(() => {
      // console.log(props)
      chart.init(props.datas);
      
    });
    return {
      myEcharts,
    };
  },
};
class InitChart {
  constructor(props, myEcharts) {
    this.props = props;
    this.myEcharts = myEcharts;
    this.state = {
      chart: null,
    };
  }

  init(resultData) {
    this.state.chart && this.destory();
    this.state.chart = echarts.init(this.myEcharts.value);

    this.state.chart.setOption({
        dataZoom: [
         {
            type: 'slider', // 内置在坐标系中

            height: 0,
            zoomLock: true,
            realtime: true,
            show: false,
            startValue: 0, // 从头开始。
            endValue: 10, // 一次性展示 10个。
         },
      ],
      tooltip: {
         trigger: 'axis',
         formatter(param) {
            let html = ''
            if (param.length > 0) {
               const { value, marker } = param[0]
               html += `${marker}${value.name}:${value.value}个`
            }
            return html
         },
      },
      grid: {
         top: '15%',
         bottom: '5%',
         left: '5%',
         right: '5%',
         containLabel: true,
      },
      dataset: [
         {
            source: resultData,
            dimensions: ['name', 'value'],
         },
      ],
      xAxis: [
         {
            type: 'category',
            axisLabel: {
               interval: 0,
               color: 'rgba(255,255,255,.8)',
               fontSize: 24,
               rotate: this.xRotate ? this.xRotate : 0,
               formatter(val) {
                  const name = val.length > 6 ? `${val.substr(0, 5)}..` : val
                  return name
               },
            },
            axisLine: {
               show: true,
               lineStyle: {
                  color: 'rgba(255, 255, 255, 0.4)',
               },
            },
            axisTick: {
               show: false,
            },
            axisPointer: {
               type: 'shadow',
            },
         },
      ],
      yAxis: [
         {
            type: 'value',
            nameTextStyle: {
               color: '#fff',
               padding: [0, 0, 0, -30],
            },
            axisTick: {
               show: false,
            },
            axisLine: {
               show: false,
            },
            axisLabel: {
               interval: 0,
               color: 'rgba(255,255,255,.8)',
               fontSize: 24,
            },
            splitLine: {
               show:true,
               lineStyle:{
                  color:"rgba(255,255,255,.5)",
                  type: [5, 10],
                  dashOffset: 5
               }
            }
         },
      ],
   series: [

      {
         //柱体
         name: '',
         type: 'bar',
         barWidth: 30,
         barGap: '0%',
         itemStyle: {
            normal: {
               color: {
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  type: 'linear',
                  global: false,
                  colorStops: [
                     { offset: 1, color: '#1391F7' },
                     { offset: 0, color: '#0E2247' },
                  ],
               },
            },
         },
         encode: {
            x: 'name',
            y: 'value',
         },
      },
      {
         //柱子顶部
         name: '',
         type: 'pictorialBar',
         symbolSize: [19, 2],
         symbolOffset: [-1, -6],
         symbolPosition: 'end',
         label: {
            show: true,
            position: 'top',
            textStyle: {
               fontSize: 24,
               color: '#fff',
            },
         },
         itemStyle: {
            normal: {
               color: '#159AFD',
            },
         },
         encode: {
            x: 'name',
            y: 'value',
         },
      },
   ],
         
    });
    window.addEventListener("resize", () => {
      this.state.chart.resize();
    });
  }

  destory() {
    this.state.chart.dispose();
    window.removeEventListener("resize", () => {
      console.log("事件移除");
    });
  }
}
</script>
<style lang="less"></style>
